import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from 'react-redux';
import { loginItemsSelector } from '../../redux/login';

export default function Menus() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user } = useSelector(loginItemsSelector);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        {/* <Typography sx={{ minWidth: 100 }}>Contact</Typography>
        <Typography sx={{ minWidth: 100 }}>Profile</Typography> */}
        <Tooltip title="Status">
          <Box
            onClick={handleClick}
            size="small"
            sx={{ ml: 0 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 20, height: 20 }}>{user?.userDetails?.first_name?.substring(0,1)}</Avatar>
          </Box>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {/* <MenuItem onClick={handleClose}>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Avatar /> My account
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <CheckCircleIcon fontSize="small" color="success"/>
          </ListItemIcon>
          Online
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <DoNotDisturbOnIcon fontSize="small"  color="danger"/>
          </ListItemIcon>
          Do Not Disturb
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <CircleIcon fontSize="small"  color="danger"/>
          </ListItemIcon>
          Busy
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <AccessTimeIcon fontSize="small" color="warning" />
          </ListItemIcon>
          Be Right Back
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <WatchLaterIcon fontSize="small" color="warning" />
          </ListItemIcon>
         Appear Away
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <HighlightOffIcon fontSize="small" color="disabled" />
          </ListItemIcon>
         Appear Offline
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
